export enum TokenState {
  NONE,
  REQUESTABLE,
  PRESENT,
}
